import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetLearningModulesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetLearningModulesQuery = { __typename?: 'query_root', learning_modules: Array<{ __typename?: 'learning_modules', id: number, key: string, name: string, description?: string | null, audiences: Array<string>, feature: string, tiers?: Array<string> | null, driver_types?: Array<string> | null, hero_video_url?: string | null, thumbnail_url?: string | null, attachment_url?: string | null, begins_at: string, ends_at?: string | null, status: string, published_at?: string | null, created_at: string, updated_at: string }> };

export type GetLearningModuleByKeyQueryVariables = Types.Exact<{
  key: Types.Scalars['String']['input'];
}>;


export type GetLearningModuleByKeyQuery = { __typename?: 'query_root', learning_modules: Array<{ __typename?: 'learning_modules', id: number, key: string, name: string, description?: string | null, audiences: Array<string>, feature: string, tiers?: Array<string> | null, driver_types?: Array<string> | null, hero_video_url?: string | null, thumbnail_url?: string | null, attachment_url?: string | null, content: string, begins_at: string, ends_at?: string | null, status: string, published_at?: string | null, created_at: string, updated_at: string }> };


export const GetLearningModulesDocument = gql`
    query GetLearningModules {
  learning_modules(order_by: {begins_at: desc}) {
    id
    key
    name
    description
    audiences
    feature
    tiers
    driver_types
    hero_video_url
    thumbnail_url
    attachment_url
    begins_at
    ends_at
    status
    published_at
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetLearningModulesQuery__
 *
 * To run a query within a React component, call `useGetLearningModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningModulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLearningModulesQuery(baseOptions?: Apollo.QueryHookOptions<GetLearningModulesQuery, GetLearningModulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLearningModulesQuery, GetLearningModulesQueryVariables>(GetLearningModulesDocument, options);
      }
export function useGetLearningModulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLearningModulesQuery, GetLearningModulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLearningModulesQuery, GetLearningModulesQueryVariables>(GetLearningModulesDocument, options);
        }
// @ts-ignore
export function useGetLearningModulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLearningModulesQuery, GetLearningModulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetLearningModulesQuery, GetLearningModulesQueryVariables>;
export function useGetLearningModulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLearningModulesQuery, GetLearningModulesQueryVariables>): Apollo.UseSuspenseQueryResult<GetLearningModulesQuery | undefined, GetLearningModulesQueryVariables>;
export function useGetLearningModulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLearningModulesQuery, GetLearningModulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLearningModulesQuery, GetLearningModulesQueryVariables>(GetLearningModulesDocument, options);
        }
export type GetLearningModulesQueryHookResult = ReturnType<typeof useGetLearningModulesQuery>;
export type GetLearningModulesLazyQueryHookResult = ReturnType<typeof useGetLearningModulesLazyQuery>;
export type GetLearningModulesSuspenseQueryHookResult = ReturnType<typeof useGetLearningModulesSuspenseQuery>;
export type GetLearningModulesQueryResult = Apollo.QueryResult<GetLearningModulesQuery, GetLearningModulesQueryVariables>;
export const GetLearningModuleByKeyDocument = gql`
    query GetLearningModuleByKey($key: String!) {
  learning_modules(where: {key: {_eq: $key}}, order_by: {begins_at: desc}) {
    id
    key
    name
    description
    audiences
    feature
    tiers
    driver_types
    hero_video_url
    thumbnail_url
    attachment_url
    content
    begins_at
    ends_at
    status
    published_at
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetLearningModuleByKeyQuery__
 *
 * To run a query within a React component, call `useGetLearningModuleByKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningModuleByKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningModuleByKeyQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetLearningModuleByKeyQuery(baseOptions: Apollo.QueryHookOptions<GetLearningModuleByKeyQuery, GetLearningModuleByKeyQueryVariables> & ({ variables: GetLearningModuleByKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLearningModuleByKeyQuery, GetLearningModuleByKeyQueryVariables>(GetLearningModuleByKeyDocument, options);
      }
export function useGetLearningModuleByKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLearningModuleByKeyQuery, GetLearningModuleByKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLearningModuleByKeyQuery, GetLearningModuleByKeyQueryVariables>(GetLearningModuleByKeyDocument, options);
        }
// @ts-ignore
export function useGetLearningModuleByKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLearningModuleByKeyQuery, GetLearningModuleByKeyQueryVariables>): Apollo.UseSuspenseQueryResult<GetLearningModuleByKeyQuery, GetLearningModuleByKeyQueryVariables>;
export function useGetLearningModuleByKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLearningModuleByKeyQuery, GetLearningModuleByKeyQueryVariables>): Apollo.UseSuspenseQueryResult<GetLearningModuleByKeyQuery | undefined, GetLearningModuleByKeyQueryVariables>;
export function useGetLearningModuleByKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLearningModuleByKeyQuery, GetLearningModuleByKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLearningModuleByKeyQuery, GetLearningModuleByKeyQueryVariables>(GetLearningModuleByKeyDocument, options);
        }
export type GetLearningModuleByKeyQueryHookResult = ReturnType<typeof useGetLearningModuleByKeyQuery>;
export type GetLearningModuleByKeyLazyQueryHookResult = ReturnType<typeof useGetLearningModuleByKeyLazyQuery>;
export type GetLearningModuleByKeySuspenseQueryHookResult = ReturnType<typeof useGetLearningModuleByKeySuspenseQuery>;
export type GetLearningModuleByKeyQueryResult = Apollo.QueryResult<GetLearningModuleByKeyQuery, GetLearningModuleByKeyQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/learningCenter/queries/getLearningModules.query.gql}
 */
export async function getLearningModuleByKey(
  variables: GetLearningModuleByKeyQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetLearningModuleByKeyQuery['learning_modules']>
export async function getLearningModuleByKey(
  variables: GetLearningModuleByKeyQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetLearningModuleByKeyQuery>
export async function getLearningModuleByKey(
  variables: GetLearningModuleByKeyQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetLearningModuleByKeyQuery['learning_modules'] | GetLearningModuleByKeyQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetLearningModuleByKeyQuery>(
    GetLearningModuleByKeyDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.learning_modules
}

/**
 * @source {@link src/features/learningCenter/queries/getLearningModules.query.gql}
 */
export async function getLearningModules(
  variables: GetLearningModulesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetLearningModulesQuery['learning_modules']>
export async function getLearningModules(
  variables: GetLearningModulesQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetLearningModulesQuery>
export async function getLearningModules(
  variables: GetLearningModulesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetLearningModulesQuery['learning_modules'] | GetLearningModulesQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetLearningModulesQuery>(
    GetLearningModulesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.learning_modules
}